{
  "es": {
    "upsell": {
      "categories": {
        "category": "Categoría",
        "home_automation": "Domótica",
        "integration": "Integración",
        "interior_decoration": "Decoración de interiores",
        "interior_doors": "Puertas interiores",
        "kitchen": "Cocina",
        "marketing": "Marketing",
        "real_estate_agent": "Agente inmobiliario",
        "telecom": "Telecomunicaciones",
        "wood_finishing": "Acabados en madera"
      },
      "contact_us": "¿Interesado? ¡Contáctanos!",
      "decisions_partners": {
        "guidance": "Los colaboradores de decisión pueden crear o gestionar propuestas si se les da permiso.",
        "intercom": "¡Hola Ziggu! Me interesa la función de colaboradores de decisión. ¿Puedes darme más información? Un saludo, %{name}"
      },
      "decisions_proposals_multiple_approval": {
        "cta": "Chatea con nosotros para saber más",
        "description": "¿Cansado de retirar la aprobación de una propuesta para añadir cambios y volver a empezar? Necesitar varias aprobaciones no debería frenarte.",
        "description_2": "Deja que tus clientes aprueben varias propuestas dentro de la misma decisión. No hace falta retirar la aprobación de una propuesta existente ni crear una nueva decisión.",
        "description_3": "Menos complicaciones y más tiempo para centrarte en lo que de verdad importa: ¡tu cliente!",
        "intercom": "¡Hola Ziggu! Quiero que el cliente pueda aprobar varias propuestas dentro de una decisión. ¿Puedes darme más información? Un saludo, %{name}",
        "premium_add_on": "Complemento premium",
        "title": "¡Ahorra tiempo con el complemento de propuestas flexibles!"
      },
      "decisions_reminders": {
        "guidance": "Los recordatorios te permiten avisar automáticamente a los clientes de que hay propuestas pendientes de decisión.",
        "intercom": "¡Hola Ziggu! Me interesa la función de recordatorios. ¿Puedes darme más información? Un saludo, %{name}"
      },
      "financials": {
        "guidance": "Crea planes de cuotas directamente desde propuestas aprobadas y compártelos con tus clientes a través del portal del cliente.<br>Mantén tu comunicación financiera transparente y profesional, tus clientes tienen siempre una vista general clara de lo que deben pagar y cuándo.",
        "intercom": "¡Hola Ziggu! Me interesa la función de finanzas para cuotas en decisiones. ¿Puedes darme más información? Un saludo, %{name}"
      },
      "imInterested": "¡Me interesa!",
      "intercom": "¡Hola Ziggu! Me interesa saber más sobre {upsell}. ¿Puedes darme más información? Un saludo, %{name}",
      "interestedToBeListed": "Interesado en aparecer aquí",
      "lookingfor": "¿Qué estás buscando? Por ejemplo: visuales 3D, cocina, telecomunicaciones",
      "multilingual": {
        "ai_included": "Traducción con IA incluida: un clic completa los idiomas que faltan.",
        "announcements_body": "Ya puedes traducir las novedades a {languages}. En todo lo demás, la función multilingual te deja escribir una sola vez y cada cliente lo lee en su propio idioma.",
        "bar_covered": "Ya publicas en {language}",
        "bar_uncovered": "Todavía no publicas en {language}",
        "body": "Hoy todos reciben la misma versión. Con la función multilingual, cada cliente lee este contenido en el idioma que ha elegido.",
        "chip_tooltip": "{customers} cliente tiene {language} como idioma | {customers} clientes tienen {language} como idioma",
        "cta": "Pedir más información",
        "cta_expand": "Ver detalles",
        "cta_sent": "Nos pondremos en contacto",
        "customers_count": "1 cliente | {count} clientes",
        "error_intercom": "No hemos podido enviar tu pregunta. Inténtalo de nuevo.",
        "headline": "Tu {count} cliente {scope} habla {languages} | Tus {count} clientes {scope} hablan {languages}",
        "headline_single": "Tu {count} cliente {scope} habla {language}. | Todos tus {count} clientes {scope} hablan {language}.",
        "intercom": "Quiero saber más sobre la función multilingual",
        "languages_count": "1 idioma | {count} idiomas",
        "languages_other_count": "1 idioma más | {count} idiomas más",
        "missing_add": "Añadir",
        "missing_added": "{language} ya es uno de los idiomas de tu empresa",
        "missing_hint": "Lo que añadas queda disponible como idioma de traducción en todas partes, para toda tu empresa.",
        "missing_hint_announcements_only": "Lo que añadas se convierte en un idioma de traducción para toda tu empresa. Hoy lo usas en las novedades; con la función multilingual, también en todo lo demás.",
        "missing_no_permission": "Añadir idiomas de empresa requiere el rol de Propietario.",
        "missing_settings_link": "Gestionar todos los idiomas en los ajustes de empresa",
        "missing_title": "{count} cliente {scope} habla {languages} | {count} clientes {scope} hablan {languages}",
        "plan": "Enterprise",
        "scope_project": "en este proyecto",
        "scope_selection": "en esta selección"
      },
      "not_included": "¿Te interesa esta función?",
      "project_email_forwarding": {
        "cta": "Reenvía correos a {project_name}",
        "description": "Permite que todo tu equipo reenvíe correos directamente a tus proyectos de Ziggu.",
        "intercom": "¡Hola Ziggu! Me interesa la función de reenvío de correos en proyectos. ¿Puedes darme más información? Un saludo, %{name}",
        "marketplace": {
          "title": "Reenvío de correos en proyectos",
          "title_sub": "Reenvía correos directamente a tus proyectos de Ziggu."
        },
        "title": "¡Novedad! Reenvío de correos dentro de proyectos",
        "youtube_id": "vLQtH9GzAXc"
      },
      "project_experience": {
        "contactme": "Sí, puedes contactarme para esto.",
        "cta": "¿Mejorar la imagen de marca de tu proyecto?",
        "description": "URL y pantalla de inicio de sesión personalizadas del proyecto <br/> Entorno dedicado del proyecto al iniciar sesión <br/> Correos con la marca del proyecto <br/> Facilita trabajar con otras promotoras inmobiliarias en el mismo proyecto",
        "intercom": "¡Hola Ziggu! Me interesa el módulo de experiencia de proyecto. ¿Puedes darme más información? Un saludo, %{name}",
        "marketplace": {
          "title": "Experiencia de proyecto",
          "title_sub": "Mejora la imagen de marca de tu proyecto con una URL y un entorno personalizados"
        },
        "title": "¡Haz que tus clientes se sientan como en casa con la nueva Experiencia de proyecto!",
        "youtube_id": "f26cNo2rwWE"
      },
      "project_templates": {
        "cta": "¿Importar desde una plantilla?",
        "cta2": "¿Importar esta plantilla en tus proyectos? ¡Haz clic aquí para desbloquear esta función!",
        "description": "<p>Transforma la forma de gestionar tus proyectos con plantillas predefinidas que te ahorran tiempo y mantienen a tu equipo sincronizado.</p><br>\n<p><strong>Ventajas de las plantillas:</strong></p>\n<ul>\n    <li><strong>- Ahorra horas</strong> en tareas repetitivas: importa estructuras de proyecto completas en segundos.</li>\n    <li><strong>- Mejor estandarización</strong> al tener todo en un solo lugar, desde tareas hasta documentos.</li>\n    <li><strong>- Aumenta la eficiencia</strong> automatizando procesos rutinarios, para que puedas centrarte en lo que más importa.</li>\n</ul>\n<br/><strong>¡Mejora tu plan hoy y consigue más con menos esfuerzo!</strong>",
        "intercom": "¡Hola Ziggu! Me interesa la función de plantillas. ¿Puedes darme más información? Un saludo, %{name}",
        "marketplace": {
          "title": "Plantillas",
          "title_sub": "Transforma la forma de gestionar tus proyectos con plantillas predefinidas que te ahorran tiempo y mantienen a tu equipo sincronizado."
        },
        "title": "¡Trabaja de forma más inteligente con las plantillas!"
      },
      "proposal_choice_lists": {
        "guidance": "Las listas de opciones permiten que tus clientes elijan dentro de las propuestas.",
        "intercom": "¡Hola Ziggu! Me interesa la función de listas de opciones. ¿Puedes darme más información? Un saludo, %{name}"
      },
      "signatures": {
        "cta_text": "¿Necesitas firmas para tus documentos? Contáctanos",
        "guidance": "Las firmas permiten que tus clientes firmen documentos importantes de forma digital.",
        "intercom": "¡Hola Ziggu! Me interesa la función de firmas. ¿Puedes darme más información? Un saludo, %{name}"
      },
      "workflows": {
        "attach_body": "Consejo: las decisiones y encuestas también se pueden vincular a una fase. Se publican automáticamente en cuanto se alcanza la fase.",
        "cta": "Saber más",
        "cta_sent": "Nos pondremos en contacto",
        "dismiss": "Ahora no",
        "intercom": "Me gustaría saber más sobre lo que los workflows añaden a las fases.",
        "move_hint_phases": "Consejo: una fase puede publicar por sí misma sus decisiones, encuestas y tareas en cuanto se alcanza.",
        "move_hint_tasks": "Consejo: una fase también puede publicar por sí misma sus decisiones y encuestas en cuanto se alcanza."
      },
      "workflows_elements": {
        "guidance": "Tu plan actual no incluye este tipo de elemento. Se queda en la fase, pero los clientes no lo recibirán hasta que mejores tu plan.",
        "intercom": "¡Hola Ziggu! Me interesa compartir decisiones, encuestas y tareas a través de fases. ¿Puedes darme más información? Un saludo, %{name}"
      }
    }
  }
}
